export default class ProductVar {
  constructor(productVar) {
    this.type = productVar.type;
    this.value = productVar.value;

    this._parsedValue = undefined;
  }

  get parsedValue() {
    if (this._parsedValue === undefined) {
      let parsedValue;

      try {
        parsedValue = JSON.parse(this.value);
      }
      catch(e) {
        parsedValue = null;
      }

      this._parsedValue = parsedValue;
    }

    return this._parsedValue;
  }
}
